export default "__VITE_ASSET__CNF$fgWA__"